import React from "react";

const Sidebar = ({ sidebar }) => {
  const currentUserRole = localStorage.getItem("role");

  return (
    <aside className="app-sidebar sticky" id="sidebar">
      {/* Start::main-sidebar-header */}
      <div className="main-sidebar-header">
        <a href="/backoffice/dashboard/index" className="header-logo">
          <img
            src="/assets/images/brand-logos/desktop-logo.png"
            alt="logo"
            className="desktop-logo"
          />
          <img
            src="/assets/images/brand-logos/toggle-logo.png"
            alt="logo"
            className="toggle-dark"
          />
          <img
            src="/assets/images/brand-logos/desktop-dark.png"
            alt="logo"
            className="desktop-dark"
          />
          <img
            src="/assets/images/brand-logos/toggle-logo.png"
            alt="logo"
            className="toggle-logo"
          />
        </a>
      </div>
      {/* End::main-sidebar-header */}

      {/* Start::main-sidebar */}
      <div className="main-sidebar" id="sidebar-scroll">
        {/* Start::nav */}
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          <div className="slide-left" id="slide-left">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#7b8191"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
            </svg>
          </div>

          <ul className="main-menu main-content">
            {/* Iterate over sidebar items */}
            {sidebar && sidebar.length > 0 ? (
              sidebar.map(
                (item, k) =>
                  // Check if role allows display of the item
                  item.allowedRoles.includes(currentUserRole) && (
                    <li
                      key={k}
                      className={`slide ${
                        item.dropdown && item.dropdown.length > 0
                          ? "has-sub"
                          : ""
                      }`}
                    >
                      <a
                        href={item.route ? `/${item.route}` : "#"}
                        className="side-menu__item"
                      >
                        <i className={`${item.icon} side-menu__icon`}></i>
                        <span className="side-menu__label">{item.name}</span>
                        {item.dropdown && item.dropdown.length > 0 && (
                          <i className="fe fe-chevron-right side-menu__angle"></i>
                        )}
                      </a>
                      {item.dropdown && item.dropdown.length > 0 && (
                        <ul className={`slide-menu child${k}`}>
                          {item.dropdown.map(
                            (link, linkIndex) =>
                              // Check if role allows display of the dropdown link
                              link.allowedRoles.includes(currentUserRole) && (
                                <li key={linkIndex} className="slide">
                                  <a
                                    href={`/${link.route}`}
                                    className="side-menu__item"
                                  >
                                    {link.name}
                                  </a>
                                </li>
                              )
                          )}
                        </ul>
                      )}
                    </li>
                  )
              )
            ) : (
              <li>No items available</li>
            )}
          </ul>
          <div className="slide-right" id="slide-right">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#7b8191"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
            </svg>
          </div>
        </nav>
        {/* End::nav */}
      </div>
      {/* End::main-sidebar */}
    </aside>
  );
};

export default Sidebar;
